/* eslint-disable no-console */
import { RoleId, RoleIds } from '@efexteam/permission-manager';
import useTeamMembers from '@pages/teamMember/hooks/useTeamMembers';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IUseEditMember } from '../types';

const useEditMember = (): IUseEditMember => {
  const { id: teamMemberId } = useParams();

  const [teamMemberControlStatus, setTeamMemberControlStatus] = useState(false);
  const [teamMemberRole, setTeamMemberRole] = useState<RoleId>(
    RoleIds.READ_ONLY
  );
  const [isTouched, setIsTouched] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { data: teamMember, loading } = useTeamMembers();

  const teamMemberData = useMemo(
    () => teamMember?.find((x) => x.id === Number(teamMemberId)),
    [teamMember, teamMemberId]
  );

  useEffect(() => {
    if (teamMemberData) {
      setTeamMemberControlStatus(teamMemberData.isActive);
      setTeamMemberRole(teamMemberData?.platformRole?.id as unknown as RoleId);
    }
  }, [teamMemberData]);

  useEffect(() => {
    if (teamMemberData?.isActive !== teamMemberControlStatus) {
      setIsTouched(true);
      return;
    }
    if (
      teamMemberRole !== (teamMemberData?.platformRole?.id as unknown as RoleId)
    ) {
      setIsTouched(true);
      return;
    }
    setIsTouched(false);
  }, [teamMemberControlStatus, teamMemberRole, teamMemberData]);

  return {
    teamMemberId,
    teamMemberData,
    loading,
    teamMemberControlStatus,
    teamMemberRole,
    isTouched,
    openUpdateModal,
    openDeleteModal,
    updateMemberStatus: setTeamMemberControlStatus,
    updateMemberRole: setTeamMemberRole,
    setOpenUpdateModal,
    setOpenDeleteModal,
  };
};

export default useEditMember;
